import { APIMethod as ApiMethods, fetchData } from "@client";

export async function removeXlsImportConfigQuery(
  configId,
) {
  return await fetchData(`/xls-configs/${configId}`, ApiMethods.DELETE);
}
